export interface PageNavigation {
  next(): boolean;
}
